import { values } from "lodash";
import debounce from "lodash.debounce";
import React, { useCallback, useState, useEffect } from "react";
import {
  formatDuration,
  intervalToDuration,
  format,
  parse,
  isBefore,
  isAfter,
} from "date-fns";
// colors
export let Colors = {
  blue: "#0080FF",
  indigo: "#5b5efb",
  purple: "#8927f9",
  pink: "#f24a8b",
  red: "#df3c4e",
  orange: "#f85f32",
  yellow: "#f2bc16",
  green: "#2dc58c",
  teal: "#2acc9c",
  cyan: "#478ffc",
  black: "#000",
  white: "#fff",
  gray: "#6B7280",
  grayDark: "#374151",
  gray100: "#f1f2f7",
  gray200: "#E5E7EB",
  gray300: "#D1D5DB",
  gray400: "#6B7280",
  gray500: "#6B7280",
  gray600: "#4B5563",
  gray700: "#374151",
  gray800: "#1F2937",
  gray900: "#111827",
  primary: "#5f38f9",
  secondary: "#374151",
  success: "#2dc58c",
  info: "#478ffc",
  warning: "#f2bc16",
  danger: "#df3c4e",
  lighter: "#f1f2f7",
  light: "#E5E7EB",
  dark: "#1F2937",
  darker: "#111827",

  bodyColor: "#787c9e",
  bodyBg: "#f8f8f9",
  borderColor: "#d2d4e4",
  borderColorTranslucent: "rgba(0, 0, 0, 0.175)",

  linkColor: "#5f38f9",
  linkHoverColor: "#4c2dc7",
  codeColor: "#f24a8b",
  highlightBg: "#fcf2d0",
};

// list of all months in english word
export let monthList = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

let getToday = function () {
  let today = new Date();
  let dd = String(today.getDate()).padStart(2, "0");
  let mm = String(today.getMonth() + 1).padStart(2, "0");
  let yyyy = today.getFullYear();

  return yyyy + "-" + mm + "-" + dd;
};
export let today = getToday();

let getTesterday = function () {
  let today = new Date();
  let yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  let y_dd = String(yesterday.getDate()).padStart(2, "0");
  let y_mm = String(yesterday.getMonth() + 1).padStart(2, "0");
  let y_yyyy = yesterday.getFullYear();

  return y_yyyy + "-" + y_mm + "-" + y_dd;
};
export let yesterday = getTesterday();

let getCurrentMonth = function () {
  let today = new Date();
  let mm = String(today.getMonth() + 1).padStart(2, "0");
  let yyyy = today.getFullYear();

  return yyyy + "-" + mm;
};

export let currentMonth = getCurrentMonth();

// Get first and last character from string
let getInitials = function (name) {
  if (!name || typeof name !== "string") {
    return "";
  }

  const names = name.trim().split(" ");
  let initials = names[0].substring(0, 1).toUpperCase();

  if (names.length > 1) {
    initials += names[names.length - 1].substring(0, 1).toUpperCase();
  }
  return initials;
};

export let toInitials = getInitials;

export let Break = {
  mb: 420,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
  any: Infinity,
};

export function formatUnderscoreString(inputString) {
  return inputString
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
}

export const capitalizeWord = (word) =>
  word ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : "";

export const roleOptions = [
  { value: "admin", label: "Admin" },
  { value: "management", label: "Management" },
  { value: "user", label: "User" },
  { value: "daak", label: "Daak" },
];

export const deptOptions = [
  { value: "Materials Management", label: "Materials Management" },
  { value: "Execution", label: "Execution" },
  { value: "Finance", label: "Finance" },
  { value: "ED Office", label: "ED Office" },
];
export const dateRangeOptions = [
  { value: "yesterday", label: "Yesterday" },
  { value: "7_days", label: "Last 7 Days" },
  { value: "15_days", label: "Last 15 Days" },
  { value: "30_days", label: "Last 30 Days" },
  { value: "last_month", label: "Last Month" },
  { value: "3_months", label: "Last 3 Months" },
  { value: "custom", label: "Custom Date" },
];
export const statusOptions = [
  { value: "created", label: "Created" },
  { value: "in_progress", label: "In Progress" },
  { value: "approved", label: "Approved" },
  { value: "completed", label: "Completed" },
  { value: "reopened", label: "Reopened" },
  { value: "overdue", label: "OverDue" },
];
export const overviewStatusOptions = [
  { value: "in_progress", label: "In Progress" },
  { value: "approved", label: "Approved" },
  { value: "completed", label: "Completed" },
  { value: "reopened", label: "Reopened" },
  { value: "escalated", label: "Escalated" },
  { value: "overdue", label: "Overdue" },
];
export const fileSourceOptions = [
  { value: "False", label: "Internal" },
  { value: "True", label: "External" },
];
export const priorityOptions = [
  { value: "high", label: "High" },
  { value: "medium", label: "Medium" },
  { value: "low", label: "Low" },
];

export const perPageOptions = [
  { value: 10, label: "10 Per Page" },
  { value: 25, label: "25 Per Page" },
  { value: 50, label: "50 Per Page" },
  { value: 100, label: "100 Per Page" },
];

export const userStatusOptions = [
  { value: "Active", label: "Active" },
  { value: "Cancelled", label: "Inactive" },
];
export const modeloption = [
  { value: "TATA 407", label: "TATA 407" },
  { value: "TATA Ace", label: "TATA Ace" },
  { value: "Ashok Leyland Dost", label: "Ashok Leyland Dost" },
  { value: "Mahindra Bolero Pickup", label: "Mahindra Bolero Pickup" },
  { value: "Eicher 10.75", label: "Eicher 10.75" },
  { value: "BharatBenz 1217C", label: "BharatBenz 1217C" },
];
export const deviceidoption = [
  { value: "DEV001", label: "DEV001" },
  { value: "DEV002", label: "DEV002" },
  { value: "DEV003", label: "DEV003" },
  { value: "DEV004", label: "DEV004" },
  { value: "DEV005", label: "DEV005" },
];
export const busstatusoption = [
  { label: "Active", value: "Active" },
  { label: "Inactive", value: "Inactive" },
  { label: "Maintenance", value: "Maintenance" },
  { label: "Breakdown", value: "Breakdown" },
];

export const getBusStatusBadge = (status) => {
  const badgeStyles = {
    active: "bg-success",
    inactive: "bg-secondary",
    maintenance: "bg-warning text-dark",
    breakdown: "bg-danger",
  };

  const normalizedStatus = status?.toLowerCase() || "inactive";

  const className = `badge d-flex justify-content-center align-items-center ${
    badgeStyles[normalizedStatus] || badgeStyles["inactive"]
  }`;

  console.log(className);
  return className;
};

export function getBusArrivalStatus(status) {
  const statusMap = {
    "On the Way": {
      text: "On the Way",
      className: "badge text-bg-info-soft",
    },
    "Reached On Time": {
      text: "Reached On Time",
      className: "badge text-bg-success-soft",
    },
    "Reached Delayed": {
      text: "Reached Delayed",
      className: "badge text-bg-warning-soft",
    },
    "Reached Early": {
      text: "Reached Early",
      className: "badge text-bg-success-soft",
    },
    "Not Reached": {
      text: "Not Reached",
      className: "badge text-bg-danger-soft",
    },
  };

  return (
    statusMap[status] || {
      text: "Unknown",
      className: "badge text-bg-secondary-soft",
    }
  );
}

export const reportOption = [
  { label: "Bus Occupancy Report", value: "BusOccupancyreport" },
  { label: "Gender Distribution Report", value: "GenderDistributionreport" },
  { label: "Popular Stops Report", value: "PopularBusReport" },
  { label: "Driver Report", value: "DriverReport" },
  { label: "Boarding History", value: "Boarding History" },
  { label: "Exception Report", value: "Exception Report" },
  { label: "Travel History", value: "Travel history" },
  { label: "Audit Log Report", value: "Auditlog" },
  { label: "Stop Report", value: "Stop Report" },
  { label: "Bus Travel Log", value: "Travel Log" },
  { label: "Bus Replacement Log", value: "Replace Log" },
];

export const getDepartmentLabel = (value) =>
  deptOptions.find((option) => option.value === value)?.label || value;

export const convertTime = (timeStr) => {
  if (!timeStr) return null;
  const fakeDate = '1970-01-01'; // or use today's date
  const fullDateStr = `${fakeDate}T${timeStr}`;
  const date = new Date(fullDateStr);
  return isNaN(date) ? null : date;
};
export const convertToAMPM = (time) => {
  if (!time) {
    return ""; // Return an empty string if time is invalid
  }

  // Split the input time into hours and minutes
  const [hours, minutes] = time.split(":").map(Number);

  // Determine AM or PM
  const period = hours >= 12 ? "PM" : "AM";

  // Convert the hours to 12-hour format
  const convertedHours = hours % 12 || 12;

  // Format the result
  return `${convertedHours}:${String(minutes).padStart(2, "0")} ${period}`;
};
export function formatTimeAgo(dateString) {
  if (!dateString) return "Unknown";

  const now = new Date();
  const updated = new Date(dateString);
  const diffMs = now - updated;
  const diffSeconds = Math.floor(diffMs / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffHours < 24) {
    if (diffHours >= 1)
      return `${diffHours} hour${diffHours > 1 ? "s" : ""} ago`;
    if (diffMinutes >= 1)
      return `${diffMinutes} minute${diffMinutes > 1 ? "s" : ""} ago`;
    return `${diffSeconds} second${diffSeconds > 1 ? "s" : ""} ago`;
  } else {
    return `${diffDays} day${diffDays > 1 ? "s" : ""} ago`;
  }
}

export const getFormattedDuration = (hhmmss) => {
  if (!hhmmss || typeof hhmmss !== "string") return "N/A";

  const [hours, minutes, seconds] = hhmmss.split(":").map(Number);
  const totalSeconds =
    (hours || 0) * 3600 + (minutes || 0) * 60 + (seconds || 0);

  if (totalSeconds === 0) return "0 mins";

  const duration = intervalToDuration({
    start: 0,
    end: totalSeconds * 1000,
  });

  return formatDuration(duration, { format: ["hours", "minutes"] });
};

export function useWindowWidth() {
  const [width, setWidth] = useState(() => window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return width;
}
export const convertTo12HourFormats = (timeStr) => {
  if (!timeStr) return "N/A";

  try {
    const parsedTime = parse(timeStr, "HH:mm:ss", new Date());
    return format(parsedTime, "hh:mm a");
  } catch (err) {
    console.error("Invalid time format:", timeStr);
    return "Invalid time";
  }
};
export const renderTripDuration = (start, end) => {
  const now = new Date();

  if (start && end) {
    const isLive = isBefore(start, now) && isAfter(end, now);

    const badgeClass = isLive ? "bg-success text-white" : "bg-light text-dark";

    const dotClass = isLive ? "bg-danger pulse-dot" : "bg-secondary";

    return (
      <span
        className={`d-inline-flex align-items-center badge fw-normal rounded-pill gap-1 ${badgeClass}`}
        style={{ padding: "0.4em 0.75em" }}
      >
        {/* Live/Offline Dot */}
        <span
          className={`rounded-circle ${dotClass}`}
          style={{ width: "10px", height: "10px", display: "inline-block" }}
        ></span>

        {/* Time Range */}
        <span>
          {format(start, "hh:mm a")} - {format(end, "hh:mm a")}
        </span>
      </span>
    );
  }

  return <span className="text-muted">-</span>;
};
